import React, { useMemo } from "react";

// Lightweight CSS-only gold particle field
export default function Particles({ count = 30 }) {
  const items = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const left = Math.random() * 100;
        const size = 1 + Math.random() * 3;
        const duration = 12 + Math.random() * 18;
        const delay = -Math.random() * duration;
        const opacity = 0.4 + Math.random() * 0.6;
        return {
          id: i,
          style: {
            left: `${left}%`,
            bottom: `-10vh`,
            width: `${size}px`,
            height: `${size}px`,
            animationDuration: `${duration}s`,
            animationDelay: `${delay}s`,
            opacity,
          },
        };
      }),
    [count]
  );

  return (
    <div className="particles" aria-hidden="true">
      {items.map((p) => (
        <span key={p.id} className="particle" style={p.style} />
      ))}
    </div>
  );
}
